<mat-dialog-content>
  <section class="crop-section">
    <h5 class="crop-section-title">{{ data.title }}</h5>
    <image-cropper
      [imageChangedEvent]="data.imageChangedEvent"
      [maintainAspectRatio]="true"
      [aspectRatio]="1"
      [resizeToWidth]="360"
      [transform]="transform"
      format="jpeg"
      output="base64"
      (imageCropped)="imageCropped($event)"
    >
    </image-cropper>
  </section>

  <section class="preview-section">
    <h5 class="crop-section-title">{{ 'SHARED.DIALOGS.IMAGE_CROP_DIALOG.PREVIEW' | translate }}</h5>
    <img
      class="preview-image"
      [src]="croppedImage"
      [alt]="'SHARED.DIALOGS.IMAGE_CROP_DIALOG.PREVIEW' | translate"
    />
  </section>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button class="cancel-button" mat-dialog-close>
    {{ 'SHARED.DIALOGS.IMAGE_CROP_DIALOG.CLOSE' | translate }}
  </button>
  <button mat-raised-button color="primary" mat-dialog-close="{{ getCroppedImage() }}">
    {{ data.sharedButtonText }}
  </button>
</mat-dialog-actions>
